// extracted by mini-css-extract-plugin
module.exports = {"tenantUnavailable":"TenantUnavailable_tenantUnavailable__ODgUW","icon":"TenantUnavailable_icon__33Fho","message":"TenantUnavailable_message__3RJoj"};